import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import CloseIcon from "../../../assets/images/icons/close_icon.svg"
import {
    makeAjax,
    respStatus,
    showMessage,
    url,
} from "../../../helpers/global_helper";

const NotificationMoPopup = (props) => {
    const { onClose, notificationId, notificationSubject } = props
    const [notificationData, setNotificationData] = useState([]);

    // api for Notification Result Popup
    const fetchNotificationResultData = () => {
        let reqData = {
            notification_id: notificationId,
        };
        makeAjax(url.PLAYER_API.getNotification, reqData, url.PLAYER_MS_EXT).then(
            (response) => {
                if (response.status != respStatus["SUCCESS"]) {
                    showMessage(response);
                    return;
                }
                setNotificationData(response.data);
            }
        );
    };

    useEffect(() => {
        if (notificationId) {
            fetchNotificationResultData();
        }
    }, [notificationId]);

    return (
        <>
            <div className="notification_sub_popup_overlay"></div>
            <div className="notification_sub_popup">

                <div className="notification_Details">
                    <button onClick={onClose}><img src={CloseIcon} alt="" /></button>
                    <h2>{props.t("information")}</h2>
                    <div className="notification_body">
                        <h3>
                            {notificationSubject}
                        </h3>
                        <p dangerouslySetInnerHTML={{ __html: notificationData }}></p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default withTranslation()(NotificationMoPopup);
